import React, { Component } from "react";
import { choice, choices } from "../../interfaces";
import Timer from "../Timer/Timer";
import "./ChoiceComponent.css";

interface functions {
	goToVideo: (gotoId: string) => void;
}

interface props {
	paused: boolean;
}

export default class ChoiceComponent extends Component<choice & functions & props> {
	componentDidMount() {
		document.addEventListener("keydown", this.choiceKeyDownFunction, false);
	}
	componentWillUnmount() {
		document.removeEventListener("keydown", this.choiceKeyDownFunction, false);
	}
	choiceKeyDownFunction = (event: KeyboardEvent) => {
		if (this.props.active) {
			if (event.key === "ArrowLeft") {
				if (this.props.choices[0].disabled) {
					return;
				} else {
					this.props.goToVideo(this.props.choices[0].gotoId);
				}
			} else if (event.key === "ArrowRight") {
				if (this.props.choices[1].disabled) {
					return;
				} else {
					this.props.goToVideo(this.props.choices[1].gotoId);
				}
			}
		}
	};
	render() {
		const listChoices = this.props.choices.map((choices: choices, index: number) => (
			<li
				key={index}
				onClick={() => {
					this.props.goToVideo(choices.gotoId);
				}}
				className={"question-item d-flex align-items-center justify-content-center " + (choices.disabled ? "disabled" : "")}
			>
				<div className="description-container">
					{/* <h3>Mulighed {index + 1}</h3> */}
					<h3>{choices.desc}</h3>
				</div>
			</li>
		));
		return (
			<div className={"questions-container " + (this.props.active ? "show" : "hide")}>
				<ul className="questions d-flex flex-row flex-wrap justify-content-around">{listChoices}</ul>
				<Timer active={this.props.active} duration={this.props.duration} paused={this.props.paused} />
			</div>
		);
	}
}
